import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/img/navlogo.png'


const _hoisted_1 = {
  class: "navbar navbar-expand navbar-light d-none d-md-flex px-6 ps-0",
  id: "topbar"
}
const _hoisted_2 = { class: "container-fluid" }
const _hoisted_3 = {
  "aria-label": "breadcrumb",
  class: "me-auto ms-4"
}
const _hoisted_4 = { class: "breadcrumb fw-bold" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = ["onClick"]
const _hoisted_7 = {
  class: "breadcrumb-item active d-flex align-items-center",
  "aria-current": "page"
}
const _hoisted_8 = {
  key: 0,
  class: "navbar-nav"
}
const _hoisted_9 = {
  key: 1,
  class: "navbar-user"
}
const _hoisted_10 = { class: "navbar-nav" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "nav-link text-paragraph" }
const _hoisted_13 = { class: "nav-item" }
const _hoisted_14 = { class: "nav-link text-paragraph d-flex align-items-center gap-2" }
const _hoisted_15 = ["src"]
const _hoisted_16 = { class: "nav-link text-paragraph d-flex align-items-center gap-2" }
const _hoisted_17 = ["src"]
const _hoisted_18 = { class: "nav-item d-flex align-items-center" }
const _hoisted_19 = { class: "text-subtitle me-3" }
const _hoisted_20 = ["src"]
const _hoisted_21 = {
  key: 1,
  class: "fa-solid fa-user-circle display-3 text-muted"
}

import { computed } from "vue";
import { storeToRefs } from "pinia";
import { useSessionStore } from "@/store/useSessionStore";
import paths from "@/router/paths";
import { getNavLinks, isNavLinkActive, tabIcon } from "./navLinks";
import NotificationBell from "@/components/app/NotificationBell.vue";
import { EventBus, EventBusNames } from "@/utils/EventBus";
import { useRoute } from "vue-router";


export default /*@__PURE__*/_defineComponent({
  __name: 'Navbar',
  props: {
    link: {},
    linkName: {},
    sublink: {},
    sublinkName: {},
    current: {}
  },
  setup(__props: any) {



const route = useRoute();
const { session } = storeToRefs(useSessionStore());
const openPamia = () => EventBus.$emit(EventBusNames.OPEN_PAMIA);
const pamiaIcon = tabIcon("pamia");
const displayName = computed(
  () => session.value?.nickname || session.value?.name?.split(" ")[0],
);

const links = getNavLinks(paths);


return (_ctx: any,_cache: any) => {
  const _component_VersionComponent = _resolveComponent("VersionComponent")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, {
        to: _unref(paths).home,
        class: "d-flex align-items-center"
      }, {
        default: _withCtx(() => [
          _cache[0] || (_cache[0] = _createElementVNode("img", {
            src: _imports_0,
            class: "rounded me-2",
            alt: ""
          }, null, -1)),
          _createVNode(_component_VersionComponent)
        ]),
        _: 1
      }, 8, ["to"]),
      _createElementVNode("nav", _hoisted_3, [
        _createElementVNode("ol", _hoisted_4, [
          (__props.link)
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 0,
                custom: "",
                to: __props.link
              }, {
                default: _withCtx(({ navigate }) => [
                  _createElementVNode("li", {
                    onClick: navigate,
                    class: "breadcrumb-item d-flex align-items-center cursor-pointer"
                  }, [
                    _createElementVNode("a", null, _toDisplayString(__props.linkName), 1)
                  ], 8, _hoisted_5)
                ]),
                _: 1
              }, 8, ["to"]))
            : _createCommentVNode("", true),
          (__props.sublink)
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 1,
                custom: "",
                to: __props.sublink
              }, {
                default: _withCtx(({ navigate }) => [
                  _createElementVNode("li", {
                    onClick: navigate,
                    class: "breadcrumb-item d-flex align-items-center cursor-pointer"
                  }, [
                    _createElementVNode("a", null, _toDisplayString(__props.sublinkName), 1)
                  ], 8, _hoisted_6)
                ]),
                _: 1
              }, 8, ["to"]))
            : _createCommentVNode("", true),
          _createElementVNode("li", _hoisted_7, _toDisplayString(__props.current), 1)
        ])
      ]),
      (!_unref(session))
        ? (_openBlock(), _createElementBlock("ul", _hoisted_8, [
            _createVNode(_component_router_link, {
              "active-class": "router-link-active",
              to: _unref(paths).login
            }, {
              default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                _createElementVNode("li", { class: "nav-item" }, [
                  _createElementVNode("a", { class: "nav-link text-paragraph btn btn-sm btn-white fw-bold" }, "Entrar")
                ], -1)
              ]))]),
              _: 1
            }, 8, ["to"])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createElementVNode("ul", _hoisted_10, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(links), (link, index) => {
                return (_openBlock(), _createElementBlock(_Fragment, {
                  key: link.title
                }, [
                  (link.navigate)
                    ? (_openBlock(), _createElementBlock("li", {
                        key: 0,
                        class: "nav-item cursor-pointer",
                        onClick: ($event: any) => (link.navigate())
                      }, [
                        _createElementVNode("a", _hoisted_12, _toDisplayString(link.title), 1)
                      ], 8, _hoisted_11))
                    : (_openBlock(), _createBlock(_component_router_link, {
                        key: 1,
                        "active-class": "nav-route-matched",
                        "exact-active-class": "nav-route-exact",
                        class: _normalizeClass({ 'router-link-active': _unref(isNavLinkActive)(_unref(route).path, link.to) }),
                        to: link.to
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("li", _hoisted_13, [
                            _createElementVNode("a", _hoisted_14, [
                              (link.icon)
                                ? (_openBlock(), _createElementBlock("img", {
                                    key: 0,
                                    src: _unref(isNavLinkActive)(_unref(route).path, link.to) ? link.icon.active : link.icon.inactive,
                                    alt: "",
                                    class: "nav-tab-icon"
                                  }, null, 8, _hoisted_15))
                                : _createCommentVNode("", true),
                              _createTextVNode(_toDisplayString(link.title), 1)
                            ])
                          ])
                        ]),
                        _: 2
                      }, 1032, ["class", "to"])),
                  (index === 1)
                    ? (_openBlock(), _createElementBlock("li", {
                        key: 2,
                        class: "nav-item cursor-pointer",
                        id: "navbar-pamia",
                        onClick: openPamia
                      }, [
                        _createElementVNode("a", _hoisted_16, [
                          _createElementVNode("img", {
                            src: _unref(pamiaIcon).inactive,
                            alt: "",
                            class: "nav-tab-icon"
                          }, null, 8, _hoisted_17),
                          _cache[2] || (_cache[2] = _createTextVNode("Pamia ", -1))
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ], 64))
              }), 128)),
              _createElementVNode("li", _hoisted_18, [
                _createVNode(NotificationBell, {
                  id: "navbar-notifications",
                  label: ""
                })
              ])
            ]),
            _cache[3] || (_cache[3] = _createElementVNode("span", { class: "text-paragraph text-muted navbar-pipe" }, "|", -1)),
            _createVNode(_component_router_link, {
              to: _unref(paths).more,
              class: "d-flex align-items-center text-decoration-none text-primary",
              id: "navbar-profile"
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_19, _toDisplayString(displayName.value), 1),
                (_unref(session)?.formatted_image)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: _unref(session)?.formatted_image,
                      alt: "",
                      width: "40",
                      height: "40",
                      class: "rounded-circle"
                    }, null, 8, _hoisted_20))
                  : (_openBlock(), _createElementBlock("i", _hoisted_21))
              ]),
              _: 1
            }, 8, ["to"])
          ]))
    ])
  ]))
}
}

})